var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4,
    stroke: "#4350F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.339 6.678v11.937l-4.165-4.268a.65.65 0 0 0-.467-.199.67.67 0 0 0-.662.679c0 .187.074.357.194.48l5.294 5.426a.66.66 0 0 0 .029.027l.027.025.002.001c.004.004.01.009.017.013l.033.024a.406.406 0 0 0 .027.017l.003.001.027.016.003.002a.19.19 0 0 0 .024.011l.03.014.034.013h.005l.023.01h.005c.006.002.018.006.03.008a.487.487 0 0 0 .098.015l.036.001h.033c.02 0 .04-.002.058-.004h-.003.009-.004a.597.597 0 0 0 .045-.008h-.004a1.134 1.134 0 0 0 .06-.013h-.004l.044-.013-.005.001.029-.01-.004.001a.989.989 0 0 0 .089-.043l.038-.024.025-.018a.816.816 0 0 0 .042-.035l.034-.031 5.293-5.426a.684.684 0 0 0 .2-.486.67.67 0 0 0-.661-.678h-.02a.653.653 0 0 0-.454.205l-4.164 4.268V6.68A.67.67 0 0 0 16 6.003h-.01a.667.667 0 0 0-.651.676zm-4.905 16.965h-.006c-.236 0-.428.304-.428.679 0 .374.192.678.428.678h11.144c.236 0 .428-.304.428-.678 0-.375-.192-.679-.428-.679H10.435z",
    fill: "#4350F7",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.b74c3750.svg";
export { ForwardRef as ReactComponent };